<tt-page *ngIf="!!setting">
    <div *ngIf="'mobile' | mediaQuery">
        <tt-card class="col-xs-12 sp-0">
            <ng-container *ngTemplateOutlet="search"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>

        <ng-container *ngTemplateOutlet="list"></ng-container>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="search"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <ng-container *ngTemplateOutlet="buttons"></ng-container>
            </tt-card>
        </div>

        <div class="col-xs-12 col-md-4 p-5">
            <ng-container *ngTemplateOutlet="list"></ng-container>
        </div>
    </div>
</tt-page>

<ng-template #search>
    <ng-container *ngIf="!!setting">
        <tt-input ttLabel="prodgrps_searchtext" ttFocus [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!setting">
        <tt-button-goto ttText="prodgrps_new" ttGoto="prodgrp" [ttGotoParms]="{ prodgrp_id: '+' }" ttIcon="far fa-plus"></tt-button-goto>
    </ng-container>
</ng-template>

<ng-template #list>
    <ng-container *ngIf="!!setting">
        <tt-list [ttData]="itemsListProductGroups" [ttFilter]="setting.searchtext"></tt-list>
    </ng-container>
</ng-template>
